module.exports = __webpack_public_path__ + "img/img99.23edf3ea.png";